import { render, staticRenderFns } from "./FeaturedImage.vue?vue&type=template&id=36d9d8ca&scoped=true"
import script from "./FeaturedImage.vue?vue&type=script&lang=js"
export * from "./FeaturedImage.vue?vue&type=script&lang=js"
import style0 from "./FeaturedImage.vue?vue&type=style&index=0&id=36d9d8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d9d8ca",
  null
  
)

export default component.exports